import { useAuthorizedMutation, useAuthorizedQuery } from "../index";
import { params } from "../../params";
import { Simulator } from "@/api/simulator/simulator.model";

export const useGetReleases = (enabled: boolean) => {
  return useAuthorizedQuery({
    url: `${params.API_URL}/platform/releases`,
    queryKey: "get-releases",
    method: "GET",
    enabled,
  });
};

export const useCreateNewRelease = () => {
  return useAuthorizedMutation({
    url: `${params.API_URL}/platform/releases/0`,
    method: "PUT",
  });
};

export const useCreateSimulator = () => {
  return useAuthorizedMutation<Simulator>({
    url: `${params.API_URL}/platform/simulators/0`,
    method: "PUT",
  });
};
export const useUpdateSimulator = ({
  simulatorId,
}: {
  simulatorId: number;
}) => {
  return useAuthorizedMutation({
    url: `${params.API_URL}/platform/simulators/${simulatorId}`,
    method: "PUT",
  });
};
export const useDeleteSimulator = ({
  simulatorId,
}: {
  simulatorId: number;
}) => {
  return useAuthorizedMutation({
    url: `${params.API_URL}/platform/simulators/${simulatorId}`,
    method: "DELETE",
  });
};
export const useUpdateRelease = (releaseId: number) => {
  return useAuthorizedMutation({
    url: `${params.API_URL}/platform/releases/${releaseId}`,
    method: "PUT",
  });
};

export const usePublishRelease = (releaseId: number, simulatorId: number) => {
  return useAuthorizedMutation({
    url: `${params.API_URL}/platform/simulators/${simulatorId}/releases/${releaseId}`,
    method: "POST",
  });
};

export const usePublishTopicFromDraft = (
  simulatorId: number,
  topicId: number
) => {
  return useAuthorizedMutation({
    url: `${params.API_URL}/platform/topic-release-policies/simulators/${simulatorId}/topics/${topicId}/publish-from-draft`,
    method: "POST",
  });
};

export const usePublishGlobalInstructionsFromDraft = (simulatorId: number) => {
  return useAuthorizedMutation({
    url: `${params.API_URL}/platform/global-instructions/simulators/${simulatorId}/publish-from-draft`,
    method: "POST",
  });
};

export const useGetReleaseConversations = (
  enabled: boolean,
  releaseId: number
) => {
  return useAuthorizedQuery({
    url: `${params.API_URL}/platform/releases/${releaseId}/conversations`,
    queryKey: `get-release-conversations-${releaseId}`,
    method: "GET",
    enabled,
  });
};

export const useGetSimulators = (enabled: boolean) => {
  return useAuthorizedQuery({
    url: `${params.API_URL}/platform/simulators`,
    queryKey: "get-simulators",
    method: "GET",
    enabled,
  });
};

export const useGetSimulatorById = (enabled: boolean, simulatorId: number) => {
  return useAuthorizedQuery({
    url: `${params.API_URL}/platform/simulators/${simulatorId}`,
    queryKey: `get-simulator-by-id-${simulatorId}`,
    method: "GET",
    enabled,
  });
};
